import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b889d04e&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.styl?vue&type=style&index=0&id=b889d04e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b889d04e",
  null
  
)

export default component.exports